module.exports = __webpack_public_path__ + "img/Weapon_122.1e45fe50.png";